import { apiCallPost } from "../api";
import { apiPaths } from "../config/apiPaths";

export const getCampaignAnalyticsApi = async (payload = {}, authHeaders = {}) => {
  try {
    const res = await apiCallPost(apiPaths.whatsappAnalytics, payload, authHeaders);
    return res;
  } catch (err) {
    return { status: false, errMsg: err.message || 'Failed to fetch campaign analytics' };
  }
};
